<template>
<div tabindex="0" class="e-card" id="price">
  <div class="e-card-title" style="display: inline-block">New Search Request Price</div>
    <div>
      <div class="e-card-content">
        <div class="form-row">
          <div style="width:80%;" class="form-row-input">
            <ejs-dropdownlist
            float-label-type="Always"
            :dataSource='productTypes'
            :fields='productTypeFields'
            placeholder='Select a product'
            v-model='productId' >
            </ejs-dropdownlist>
          </div>
        </div>

        <div class="form-row">
          <div style="width:40%;" class="form-row-input">
            <ejs-textbox float-label-type="Always"
                        placeholder="Charge By"
                        v-model="chargeBy"
                        readonly="true"
                        />
          </div>
        </div>

        <div class="form-row">
          <div style="width:10%;" class="form-row-input">
            <scc-input-validator
              :rules="[positiveNumberRule]"
              :number="this.amountPerAddress"
              @validate="(v) => (this.isAmountPerAddressValid = v)"
            >
              <ejs-numerictextbox
              float-label-type="Always"
              placeholder="Per Address*"
              format="C2"
              :showSpinButton="spin"
              v-model="amountPerAddress" />
            </scc-input-validator>
          </div>
        </div>
        <div class="form-row">
          <div  class="form-row-input">Levy Fee Type</div>
        </div>
        <div class="form-row">
          <div style="width:80%;" class="form-row-input">
            <ejs-radiobutton label='% Percentage' name='levyTypeSelect'
            :checked="levyFeeType === '%'"
            :htmlAttributes="{ value: '%' }"  v-model='levyFeeType'/>
            &nbsp;&nbsp;
            <ejs-radiobutton label='$ Amount' name='levyTypeSelect'
            :checked="levyFeeType === '$'"
            :htmlAttributes="{ value: '$' }"  v-model='levyFeeType'/>
          </div>
        </div>

        <div class="form-row">
          <div style="width:10%;" class="form-row-input">
              <scc-input-validator
              :rules="[positiveNumberRule]"
              :number="this.amountLevy"
              @validate="(v) => (this.isAmountLevyValid = v)"
              >
                <ejs-numerictextbox
                float-label-type="Always"
                placeholder="Levy*"
                :showSpinButton="spin"
                v-model="amountLevy" />
              </scc-input-validator> &nbsp;
          </div>
          <div style="flex:1; font-weight: bold;">&nbsp; {{levyFeeType}}</div>
        </div>

        <div class="form-row">
          <div style="width:18%;" class="form-row-input">
            <ejs-datepicker
            v-model="effectiveStartDate"
            :placeholder="dateMarker"
            :min="minVal"
            :max="maxVal"
            float-label-type="Always"
            :format="dateFormat"></ejs-datepicker>
          </div>
        </div>

        <div class="align-center-bottom">
        <ejs-button type="button" v-on:click.native="onSubmitButtonClick"
                      cssClass="e-info margin-button">Submit</ejs-button>
        <ejs-button v-on:click.native="onCancelButtonClick"
                      cssClass="e-danger margin-button">Cancel</ejs-button>
        </div>
    </div>
  </div>
</div>
</template>

<script>
import Vue from 'vue';
import { TextBoxPlugin, NumericTextBoxPlugin } from '@syncfusion/ej2-vue-inputs';
import { DropDownListPlugin } from '@syncfusion/ej2-vue-dropdowns';
import { DatePickerPlugin } from '@syncfusion/ej2-vue-calendars';
import { RadioButtonPlugin } from '@syncfusion/ej2-vue-buttons';
import SccInputValidator from '@/components/base/scc-input-validator.vue';

import { POST_PRODUCT_PRICE, FETCH_PRODUCT_PRICE } from '../store';

Vue.use(TextBoxPlugin);
Vue.use(NumericTextBoxPlugin);
Vue.use(DropDownListPlugin);
Vue.use(DatePickerPlugin);
Vue.use(RadioButtonPlugin);

export default {
  name: 'AddSearchRequestPrice',
  components: {
    SccInputValidator,
  },
  data() {
    return {
      priceId: null,
      title: 'New Price',
      productId: null,
      productType: '',
      amountApp: 0,
      amountTank: 0,
      amountLevy: 0,
      amountPerAddress: 0,
      chargeBy: '',
      effectiveStartDate: null,
      allowChangeProductType: true,
      productDescription: '',
      dateMarker: 'Select Start Date(yyyy-mm-yy)',
      dateFormat: 'yyyy-MM-dd',
      productTypes: [],
      productTypeFields: { text: 'productDescription', value: 'productId' },
      hideChargeBy: true,

      chargeByOptions: [],
      chargeByFields: { text: 'chargeBy', value: 'chargeBy' },

      levyFeeType: null,
      levyFeeTypes: [{ label: 'percentage', value: '%' }, { label: 'amount', value: '$' }],
      positiveNumberRule: {
        regEx: '^(\\+)?\\d+(\\.\\d*)?$',
        message: 'Please provide a positive amount.',
      },
      isAmountPerAddressValid: false,
      isAmountLevyValid: false,
      spin: false,
    };
  },

  created() {
    this.productTypes = this.$store.getters.productTypes.filter((x) => x.productType === 'Search');
    if (this.productTypes !== null && this.productTypes.length === 1) {
      this.productDescription = this.productTypes[0].productDescription;
      this.productId = this.productTypes[0].productId;
    }
    // To Add Filter here
    this.chargeByOptions = this.$store.getters.chargeByOptions;

    if (this.$route.params.id !== '0') {
      this.priceId = this.$route.params.id;
      this.allowChangeProductType = false;
      this.FetchProductPrice();
    } else {
      this.priceId = '';
    }

    this.chargeBy = 'Per Address';
  },

  computed: {
    canChangeProductType() {
      return this.allowChangeProductType;
    },
    minVal() {
      const today = new Date();
      const currentYear = today.getFullYear();
      const currentMonth = today.getMonth();
      const currentDay = today.getDate() + 1;
      return new Date(currentYear, currentMonth, currentDay);
    },
    maxVal() {
      const today = new Date();
      const currentYear = today.getFullYear() + 2;
      const currentMonth = today.getMonth();
      const currentDay = today.getDate();
      return new Date(currentYear, currentMonth, currentDay);
    },
  },

  methods: {

    ValidateAmounts() {
      this.amountPerAddress = this.amountPerAddress == null ? 0 : this.amountPerAddress;
      this.amountLevy = this.amountLevy == null ? 0 : this.amountLevy;
    },

    onChargeByChange() {
      if (this.chargeBy === 'Application') {
        this.amountTank = 0;
      }

      if (this.chargeBy === 'Each Tank') {
        this.amountApp = 0;
      }
    },
    onCancelButtonClick() {
      this.$router.push('/products/productprices/');
    },
    async onSubmitButtonClick() {
      if (this.productId === null || this.productId === '') {
        this.$parent.$parent.notificationToasts.push({
          title: 'Error!',
          content: 'Please select a product type first!',
          cssClass: 'e-toast-info',
          timeOut: 5000,
        });
        this.$parent.$parent.$refs.notifierRef.show();
        return;
      }
      let formDataFail = false;
      let errorMessage = '';
      if (this.amountPerAddress === null || this.amountPerAddress === '' || this.amountPerAddress === 0) {
        formDataFail = true;
        errorMessage += 'Please check Per Address amount values!<br>';
      } else {
        this.isAmountPerAddressValid = true;
      }
      if (this.effectiveStartDate === null) {
        formDataFail = true;
        errorMessage += 'Please select start date!<br>';
      }
      this.isAmountLevyValid = true;
      if (formDataFail) {
        this.$parent.$parent.notificationToasts.push({
          title: 'Error!',
          content: errorMessage,
          cssClass: 'e-toast-danger',
          timeOut: 5000,
        });
        this.$parent.$parent.$refs.notifierRef.show();
        return;
      }
      if (this.isAmountPerAddressValid && this.isAmountLevyValid) {
        try {
          const data = {};
          if (this.priceId !== null && this.priceId !== '') {
            data.priceId = this.priceId;
          }
          data.productId = this.productId;
          data.amountApp = this.amountApp;
          data.amountTank = this.amountTank;
          data.amountLevy = this.amountLevy;
          data.amountPerAddress = this.amountPerAddress;
          data.levyFeeType = this.levyFeeType;
          data.chargeBy = this.chargeBy;
          data.effectiveStartDate = this.effectiveStartDate;

          await this.$store.dispatch(POST_PRODUCT_PRICE, { data });
          this.$parent.$parent.notificationToasts.push({
            title: 'Success!',
            content: 'Search Request price saved.',
            cssClass: 'e-toast-success',
            timeOut: 5000,
          });
          this.$router.push('/products/productprices/');
        } catch (error) {
          console.error(error);
        }
      } else {
        this.$parent.$parent.notificationToasts.push({
          title: 'Error!',
          content: 'Please verify the form data.',
          cssClass: 'e-toast-danger',
          timeOut: 5000,
        });
      }
      if (this.$parent.$parent.notificationToasts.length > 0) {
        this.$parent.$parent.$refs.notifierRef.show();
      }
    },

    async FetchProductPrice() {
      if (this.priceId != null && this.priceId !== '' && this.priceId !== '0') {
        const { priceId } = this;
        this.title = 'Update Product Price';
        await this.$store.dispatch(FETCH_PRODUCT_PRICE, { priceId });

        const {
          amountApp, amountTank, amountLevy, amountPerAddress,
          levyFeeType, chargeBy, effectiveStartDate, effectiveEndDate,
        } = this.$store.getters.currentPrice;
        // this.priceId = priceId;
        this.amountApp = amountApp;
        this.amountTank = amountTank;
        this.amountLevy = amountLevy;
        this.amountPerAddress = amountPerAddress;
        this.levyFeeType = levyFeeType;
        this.chargeBy = chargeBy;
        this.effectiveStartDate = effectiveStartDate;
        this.effectiveEndDate = effectiveEndDate;
      } else {
        // little difference from product prospect
        this.title = 'New Product Price';
      }
    },
  },
};
</script>

<style>
 @import '../../../assets/styles/eservices-base.css';
 .e-card-content {
  margin: 0% !important;
}
</style>
